import { Component, Input, OnInit } from '@angular/core';
import { TimelineSection } from '../../../../_models/timeline-models/section-listing.model';

@Component({
    selector: 'activity-section',
    templateUrl: './activity-section.component.html',
    styleUrls: ['./activity-section.component.css'],
    standalone: false
})
export class ActivitySectionComponent implements OnInit {

  @Input("timelineSection") timelineSection: TimelineSection;

  constructor(
  ) { }

  ngOnInit() {
  }

}
